/**
 * Details on the trade in for a deal. Any non tp_ prefixed values should come from snap
 * directly.
 */
export interface TradeIn {
    /**
     * The balance left on the trade-in.
     */
    balance?: number;
    /**
     * The condition of the vehicle chosen.
     */
    condition?: Condition;
    /**
     * The value based on the customer's condition estimate.
     */
    customer_estimate?: number;
    /**
     * The drive train of the trade-in.
     */
    drivetrain?: string;
    /**
     * TradePending's internal ID for this vehicle.
     */
    id?: string;
    /**
     * The manufacturer of the trade-in.
     */
    make?: string;
    /**
     * The model of the trade-in.
     */
    model?: string;
    /**
     * The odometer amount of the trade-in.
     */
    odometer?: Distance;
    /**
     * The high value for the trade-in.
     */
    tp_tradein_high?: number;
    /**
     * The low value for the trade-in.
     */
    tp_tradein_low?: number;
    /**
     * The URL to the trade-in report for thie trade-in.
     */
    tp_tradein_report?: string;
    /**
     * The target value for the trade-in.
     */
    tp_tradein_target?: number;
    /**
     * The trim level of the trade-in.
     */
    trim?: string;
    /**
     * The model year of the trade-in.
     */
    year?: string;
    /**
     * The year, make, model and trim as one string.
     */
    ymmt?: string;
    /**
     * Unless this is set to yes, the rest of the data will be ignored in calculations.
     */
    yn?: Yn;
}

/**
 * The condition of the vehicle chosen.
 */
export enum Condition {
    High = "high",
    Low = "low",
    Target = "target",
}

/**
 * The odometer amount of the trade-in.
 *
 * Stores distance in a localizable format (both amount and unit)
 */
export interface Distance {
    amount: number;
    unit: Unit;
}

export enum Unit {
    KM = "km",
    Mi = "mi",
}

/**
 * Unless this is set to yes, the rest of the data will be ignored in calculations.
 */
export enum Yn {
    No = "no",
    Yes = "yes",
}
